import {useTheme} from 'contexts/ThemeContext';
import React, {useEffect} from 'react';
import {Text, TextInput, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ChatTextInputProps {
  text: string;
  onChangeText: (text: string) => void;
  onFocus: () => void;
  onBlur: () => void;
}

const ChatTextInput = (props: ChatTextInputProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <TextInput
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      value={props.text}
      placeholderTextColor={theme.colors.gray}
      onChangeText={props.onChangeText}
      placeholder={strings.chat.inputPlaceholder}
      multiline={true}
      style={styles.container}
    />
  );
};

export default ChatTextInput;
